import { mobileBackgroundRssNames, mobileGameRssNames } from './mobileResourceNames';
import { SpineFile } from './clases/SpineFile';

export const crystalTypes = {
  crystal_yellow: 1,
  crystal_green: 2,
  crystal_magenta: 3,
  crystal_blue: 4,
  crystal_gold: 5,
  1: 'crystal_yellow',
  2: 'crystal_green',
  3: 'crystal_magenta',
  4: 'crystal_blue',
  5: 'crystal_gold',
};

export const DEG_TO_RAD = Math.PI / 180;

export const crystalsRssNames = {
  crystalBlue: 'crystal_blue',
  crystalGold: 'crystal_gold',
  crystalGreen: 'crystal_green',
  crystalMagenta: 'crystal_magenta',
  crystalYellow: 'crystal_yellow',
  goldenElement: 'golden_element',
  goldenRing: 'golden_ring',
};

export const crystalsResources = [
  { name: crystalsRssNames.crystalBlue, path: 'assets/crystal_blue.png' },
  { name: crystalsRssNames.crystalGold, path: 'assets/crystal_gold.png' },
  { name: crystalsRssNames.crystalGreen, path: 'assets/crystal_green.png' },
  { name: crystalsRssNames.crystalMagenta, path: 'assets/crystal_magenta.png' },
  { name: crystalsRssNames.crystalYellow, path: 'assets/crystal_yellow.png' },
];

export const backgroundAnimationNames = {
  glow: 'stones',
  blue: 'blue',
  green: 'green',
  magenta: 'purple',
  yellow: 'yellow',
  gold: 'yellow',
};

export const backgroundResourceNames = {
  coins: 'coins',
  topPlants: 'top_Plants',
  stones: 'stones',
  plants: 'plants',
  backgroundFirstLayer: 'backgroundFirstLayer',
  backgroundSecondLayer: 'backgroundSecondLayer',
  plusIcon: 'plus_icon.svg',
  freeBetButtonIcon: 'free_bet_button.png',
};

export const movingLightEffectResourceNames = {
  star: 'movingLightEffectResourceNames_star',
  lightEffectSpine: 'movingLightEffectResourceNames_lightEffectSpine',
};

export const backgroundResource = [
  {
    name: backgroundResourceNames.coins,
    path: 'coins.json',
    config: {
      metadata: {
        spineAtlasFile: 'coins.atlas',
      },
    },
  },
  {
    name: backgroundResourceNames.topPlants,
    path: 'top_plants.json',
    config: {
      metadata: {
        spineAtlasFile: 'top_plants.atlas',
      },
    },
  },
  new SpineFile({
    name: backgroundResourceNames.stones,
    path: 'animations/main_stones',
    fileName: 'stones',
  }),

  {
    name: backgroundResourceNames.plants,
    path: 'plants.json',
    config: {
      metadata: {
        spineAtlasFile: 'plants.atlas',
      },
    },
  },
  { name: backgroundResourceNames.backgroundFirstLayer, path: 'assets/backgrounds/main_background_1.png' },
  { name: backgroundResourceNames.backgroundSecondLayer, path: 'assets/backgrounds/main_background_2.png' },
  { name: mobileBackgroundRssNames.lastResultsOpacity, path: 'icons/last_results_opacity.svg' },
  { name: movingLightEffectResourceNames.star, path: 'animations/moving_light_effect/star.png' },
  { name: backgroundResourceNames.plusIcon, path: 'icons/plus_icon.svg' },
  { name: backgroundResourceNames.freeBetButtonIcon, path: 'icons/free_bet_button.png' },
  ...crystalsResources,
];

export const preBonusBackgroundResourceName = {
  preBonusCoins: 'pre_bonus_coins',
  preBonusMovingLiana: 'pre_bonus_moving_liana',
  preBonusPlants: 'pre_bonus_plants',
  preBonusStones: 'pre_bonus_stones',
  preBonusTopPlants: 'pre_bonus_top_plants',
  backgroundFirstLayer: 'pre_bonus_background_first_layer_16x9',
  backgroundSecondLayer: 'pre_bonus_background_second_layer_16x9',
};

export const bonusBackgroundResourceName = {
  bonusCoins: 'bonus_coins',
  bonusLittleLight: 'bonus_little_light',
  bonusPlants: 'bonus_plants',
  bonusStoneTreeLight: 'bonus_stone_tree_light',
  bonusStones: 'bonus_stones',
  bonusTopPlants: 'bonus_top_plants',
  backgroundFirstLayer: 'bonus_background_first_layer_16x9',
  backgroundSecondLayer: 'bonus_background_second_layer_16x9',
  bonusBackgroundLiana: 'bonus_background_2_liana_16x9',
  bonusBackgroundShiningPlants: 'bonus_background_2_shining_plants_16x9',
};

export const preBonusBackgroundResources = [
  {
    name: preBonusBackgroundResourceName.preBonusCoins,
    path: 'animations/pre_bonus_coins/coins.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/pre_bonus_coins/coins.atlas',
      },
    },
  },
  {
    name: preBonusBackgroundResourceName.preBonusMovingLiana,
    path: 'animations/pre_bonus_moving_liana/moving_liana.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/pre_bonus_moving_liana/moving_liana.atlas',
      },
    },
  },
  {
    name: preBonusBackgroundResourceName.preBonusPlants,
    path: 'animations/pre_bonus_plants/plants.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/pre_bonus_plants/plants.atlas',
      },
    },
  },
  {
    name: preBonusBackgroundResourceName.preBonusStones,
    path: 'animations/pre_bonus_stones/stones.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/pre_bonus_stones/stones.atlas',
      },
    },
  },
  {
    name: preBonusBackgroundResourceName.preBonusTopPlants,
    path: 'animations/pre_bonus_top_plants/top_plants.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/pre_bonus_top_plants/top_plants.atlas',
      },
    },
  },
  { name: preBonusBackgroundResourceName.backgroundFirstLayer, path: 'assets/backgrounds/pre_bonus_background_1.png' },
  { name: preBonusBackgroundResourceName.backgroundSecondLayer, path: 'assets/backgrounds/pre_bonus_background_2.png' },
];

export const bonusBackgroundResources = [
  { name: mobileBackgroundRssNames.lastResultsOpacity, path: 'icons/last_results_opacity.svg' },
  { name: movingLightEffectResourceNames.star, path: 'animations/moving_light_effect/star.png' },
  ...crystalsResources,
  new SpineFile({
    name: preBonusBackgroundResourceName.preBonusCoins,
    fileName: 'coins',
    path: 'animations/pre_bonus_coins',
  }),
  new SpineFile({
    name: bonusBackgroundResourceName.bonusLittleLight,
    fileName: 'little_lights',
    path: 'animations/bonus_little_light',
  }),
  new SpineFile({
    name: bonusBackgroundResourceName.bonusPlants,
    fileName: 'plants',
    path: 'animations/bonus_plants',
  }),
  new SpineFile({
    name: bonusBackgroundResourceName.bonusStoneTreeLight,
    fileName: 'light',
    path: 'animations/bonus_stone_tree_light',
  }),
  new SpineFile({
    name: bonusBackgroundResourceName.bonusStones,
    fileName: 'stones',
    path: 'animations/bonus_stones',
  }),
  new SpineFile({
    name: bonusBackgroundResourceName.bonusTopPlants,
    fileName: 'top_plants',
    path: 'animations/bonus_top_plants',
  }),
  { name: bonusBackgroundResourceName.backgroundFirstLayer, path: 'assets/backgrounds/bonus_background_1.png' },
  { name: bonusBackgroundResourceName.backgroundSecondLayer, path: 'assets/backgrounds/bonus_background_2.png' },
];

export const crystals = [
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_gold,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_green,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_yellow,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_magenta,
  crystalTypes.crystal_blue,
  crystalTypes.crystal_green,
];

export const wheelResourceNames = {
  ...crystalsRssNames,
  wheel: 'wheel_texture',
  wheelDark: 'wheel_dark_wheel_texture',
  mainWheelCrown: 'main_wheel_crown.png',
  mainWheelLight: 'main_wheel_light.png',
  wheelRing: 'main_wheel_ring.png',
  wheelScreenTransaction: 'wheelScreenTransaction',
  preBonusTransaction: 'preBonusTransaction',
  goodLuck: 'goodLuck_4455',
  noWinImage: 'noWinImage_4455',
  bonusMarker: 'bonusMarker',
  pressToContinue: 'pressToContinue',
};


export const wheelTransactionResource = [
  {
    name: wheelResourceNames.wheelScreenTransaction,
    path: 'animations/screen_transaction/wheel.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/screen_transaction/wheel.atlas',
      },
    },
  },
];

export const preBonusTransactionResource = [
  {
    name: wheelResourceNames.preBonusTransaction,
    path: 'animations/screen_transaction/preBonus.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/screen_transaction/preBonus.atlas',
      },
    },
  },
];

export const wheelResource = [
  ...crystalsResources,
  { name: wheelResourceNames.mainWheelCrown, path: 'assets/main_wheel_crown.png' },
  { name: wheelResourceNames.wheelRing, path: 'assets/main_wheel_ring.png' },
  { name: wheelResourceNames.mainWheelLight, path: 'assets/main_wheel_light.png' },
  { name: wheelResourceNames.goodLuck, path: 'assets/good_luck.png' },
  { name: wheelResourceNames.noWinImage, path: 'assets/no_win.png' },
  { name: wheelResourceNames.bonusMarker, path: 'assets/bonus_marker.png' },
  { name: wheelResourceNames.pressToContinue, path: 'assets/press_to_start.png' },
];

export const wheelLightResource = [
  { name: wheelResourceNames.wheel, path: 'assets/main_wheel.png' },
  ...wheelTransactionResource,
];

export const wheelDarkResource = [
  { name: wheelResourceNames.wheelDark, path: 'assets/bonus_wheel.png' },
  ...wheelTransactionResource,
];

export const controllerResourceNames = {
  infoIconDark: 'infoIconDark',
  infoIconActive: 'infoIconActive',
  soundOnIcon: 'soundOnIcon',
  soundOffIconDark: 'soundOffIcon',
  historyIconDark: 'historyIcon',
  historyIconActive: 'historyIconActive',
  controlWhiteCircle: 'control_white_circle',
};

export const controllerResource = [
  { name: controllerResourceNames.historyIconDark, path: 'icons/history_icon_dark.svg' },
  { name: controllerResourceNames.historyIconActive, path: 'icons/history_icon_mobile_active.svg' },
  { name: controllerResourceNames.infoIconDark, path: 'icons/info_icon_dark.svg' },
  { name: controllerResourceNames.infoIconActive, path: 'icons/info_icon_mobile_active.svg' },
  { name: controllerResourceNames.soundOnIcon, path: 'icons/sound_on_icon_mobile.svg' },
  { name: controllerResourceNames.soundOffIconDark, path: 'icons/sound_off_icon_dark.svg' },
  { name: controllerResourceNames.controlWhiteCircle, path: 'icons/control_white_circle.svg' },
];

export const gamePadResourceNames = {
  spinIcon: 'spin_icon',
  betAmountIcon: 'bet_amount_icon',
  buttonBorderNonActive: 'controller_circle_icon',
  buttonBorderActive: 'controller_circle_icon_active',
  autoplay_icon: 'auto_spin_icon',
  leftArrowIcon: 'left_arrow_icon',
  rightArrowIcon: 'right_arrow_icon',
  autoSpinTypeBetAmountContent: 'autospin_type_bet_amount',
  betAmountMinus: 'bet_amount_minus',
  betAmountPlus: 'bet_amount_plus',
  hoverAutoSpin: 'hoverAutoSpin',
  autoSpinIcon: 'auto_spin_icon',
  infinityIconDark: 'infinity_icon_dark',
};

export const gamePadLandScapeResourceNames = {
  spinIcon: 'spin_icon',
  betAmountIcon: 'bet_amount_icon',
  buttonBorderNonActive: 'button_border_active',
  buttonBorderActive: 'button_border_non_active',
  autoplayIcon: 'autoplay_icon',
  leftArrowIcon: 'left_arrow_icon',
  rightArrowIcon: 'right_arrow_icon',
  mobileController: 'mobile_controller',
  betAmountMinus: 'bet_amount_minus',
  betAmountPlus: 'bet_amount_plus',
};

export const gamePadLandScapeResources = [
  { name: gamePadLandScapeResourceNames.spinIcon, path: 'icons/spin_full_icon.svg' },
  { name: gamePadLandScapeResourceNames.betAmountIcon, path: 'icons/bet_amount_icon.svg' },
  { name: gamePadLandScapeResourceNames.buttonBorderNonActive, path: 'icons/button_border_non_active.svg' },
  { name: gamePadLandScapeResourceNames.buttonBorderActive, path: 'icons/button_border_active.svg' },
  { name: gamePadLandScapeResourceNames.autoplayIcon, path: 'icons/autoplay_icon.svg' },
  { name: gamePadLandScapeResourceNames.leftArrowIcon, path: 'icons/left_arrow_icon.svg' },
  { name: gamePadLandScapeResourceNames.rightArrowIcon, path: 'icons/right_arrow_icon.svg' },
  { name: gamePadLandScapeResourceNames.betAmountMinus, path: 'icons/bet_amount_minus.svg' },
  { name: gamePadLandScapeResourceNames.betAmountPlus, path: 'icons/bet_amount_plus.svg' },
  { name: gamePadLandScapeResourceNames.mobileController, path: 'icons/mobile_controller.svg' },
];

export const gamePadResource = [
  { name: gamePadResourceNames.spinIcon, path: 'icons/spin_full_icon.svg' },
  { name: gamePadResourceNames.autoSpinTypeBetAmountContent, path: 'icons/autospin_type_bet_amount.svg' },
  { name: gamePadResourceNames.betAmountPlus, path: 'icons/bet_amount_plus.svg' },
  { name: gamePadResourceNames.betAmountMinus, path: 'icons/bet_amount_minus.svg' },
  { name: gamePadResourceNames.hoverAutoSpin, path: 'icons/hover_autospin.svg' },
  { name: gamePadResourceNames.rightArrowIcon, path: 'icons/right_arrow_icon.svg' },
  { name: gamePadResourceNames.leftArrowIcon, path: 'icons/left_arrow_icon.svg' },
  { name: mobileGameRssNames.infinityIconDark, path: 'icons/infinity_icon_bark.svg' },
  { name: mobileGameRssNames.autoSpinIcon, path: 'icons/autospin_button.svg' },
  { name: mobileGameRssNames.infinityIcon, path: 'icons/infinity_icon.svg' },
];

export const oddCrystalsResourceNames = {
  odd2: 'odd2',
  odd3: 'odd3',
  odd5: 'odd5',
  odd60: 'odd60',
};

export const oddCrystalsResources = [
  { name: oddCrystalsResourceNames.odd2, path: 'oddImages/x_2.png' },
  { name: oddCrystalsResourceNames.odd3, path: 'oddImages/x_3.png' },
  { name: oddCrystalsResourceNames.odd5, path: 'oddImages/x_5.png' },
  { name: oddCrystalsResourceNames.odd60, path: 'oddImages/x_60.png' },
];

export const diamondNames = {
  diamond_blue: 'diamondNames_diamond_blue',
  diamond_green: 'diamondNames_diamond_green',
  diamond_magenta: 'diamondNames_diamond_magenta',
  diamond_yellow: 'diamondNames_diamond_yellow',
};

export const diamondResourcesByName = {
  [diamondNames.diamond_blue]: { name: diamondNames.diamond_blue, path: 'assets/diamond_blue.png' },
  [diamondNames.diamond_green]: { name: diamondNames.diamond_green, path: 'assets/diamond_green.png' },
  [diamondNames.diamond_magenta]: { name: diamondNames.diamond_magenta, path: 'assets/diamond_magenta.png' },
  [diamondNames.diamond_yellow]: { name: diamondNames.diamond_yellow, path: 'assets/diamond_yellow.png' },
};

export const diamondResources = [
  { name: diamondNames.diamond_blue, path: 'assets/diamond_blue.png' },
  { name: diamondNames.diamond_green, path: 'assets/diamond_green.png' },
  { name: diamondNames.diamond_magenta, path: 'assets/diamond_magenta.png' },
  { name: diamondNames.diamond_yellow, path: 'assets/diamond_yellow.png' },
];

export const bonusBoardResourceNames = {
  board: 'board',
  buttonState: 'button_state',
  buttonHoverState: 'button_hover_state',
  buttonPushedState: 'button_pushed_state',
};

export const bonusBoardResources = [
  {
    name: bonusBoardResourceNames.board,
    path: 'animations/bonus_board/board.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/bonus_board/board.atlas',
      },
    },
  },
  { name: bonusBoardResourceNames.buttonState, path: 'button/button.png' },
  { name: bonusBoardResourceNames.buttonHoverState, path: 'button/button_hover.png' },
  { name: bonusBoardResourceNames.buttonPushedState, path: 'button/button_pushed.png' },
];

export const sharedResources = [
  ...crystalsResources,
];

export const preBonusRssNames = {
  preBonusBack: 'pre_bonus_content',
  preBonusGold: 'pre_bonus_gold',
  preBonusFreeSpinContent: 'preBonusFreeSpinContent',
  preBonusMultiplierContent: 'preBonusMultiplierContent',
  preBonusCrystalsContent: 'preBonusCrystalsContent',
  bonusRectangleSmall: 'bonusRectangleSmall',
  preBonusCrystalYellow: diamondNames.diamond_yellow,
  preBonusCrystalGreen: diamondNames.diamond_green,
  preBonusCrystalBlue: diamondNames.diamond_blue,
  preBonusCrystalMagenta: diamondNames.diamond_magenta,
};

export const preBonusSharedResources = [
  { name: preBonusRssNames.preBonusBack, path: 'assets/prebonus_back.png' },
  { name: preBonusRssNames.preBonusGold, path: 'assets/prebonus_gold.png' },
  { name: preBonusRssNames.preBonusFreeSpinContent, path: 'assets/free_spins_back.png' },
  { name: preBonusRssNames.preBonusMultiplierContent, path: 'assets/multiplier_back.png' },
  { name: preBonusRssNames.preBonusCrystalsContent, path: 'assets/wins_back.png' },
  ...preBonusTransactionResource,
  ...diamondResources,
];

export const buyBonusRssNames = {
  acceptHover: 'accept_hover',
  acceptNormal: 'accept_normal',
  declineHover: 'decline_hover',
  declineNormal: 'decline_normal',
  popupBuyBonus: 'popup_buy_bonus',
};
export const congratulationsPopupRssNames = {
  background: 'congratulationsPopupRssNames_background',
};

export const congratulationsCoinRssNames = {
  congratulationsCoin: 'congratulations_coin',
};

export const stoneLightRssNames = {
  stoneLight: 'stoneLightAnimation',
};

export const congratulationsCoinResources = [
  {
    name: congratulationsCoinRssNames.congratulationsCoin,
    path: 'congratulations_coin/congratulations.json',
    config: {
      metadata: {
        spineAtlasFile: 'congratulations_coin/congratulations.atlas',
      },
    },
  },
];

export const stoneLightResources = [];

export const buyBonusResources = [
  { name: buyBonusRssNames.acceptHover, path: 'assets/accept_hover.png' },
  { name: buyBonusRssNames.acceptNormal, path: 'assets/accept_normal.png' },
  { name: buyBonusRssNames.declineHover, path: 'assets/decline_hover.png' },
  { name: buyBonusRssNames.declineNormal, path: 'assets/decline_normal.png' },
  { name: buyBonusRssNames.popupBuyBonus, path: 'assets/popup_buy_bonus.png' },
  { name: mobileBackgroundRssNames.shadow, path: 'mobileAssets/shadow.svg' },
];

export const congratulationsBonusPopupRes = [
  ...congratulationsCoinResources,
  { name: buyBonusRssNames.popupBuyBonus, path: 'assets/popup_buy_bonus.png' },
  { name: mobileBackgroundRssNames.shadow, path: 'mobileAssets/shadow.svg' },
];

export const congratulationsPopupResources = [
  ...congratulationsCoinResources,
  { name: congratulationsPopupRssNames.background, path: 'assets/congratulations_popup.png' },
];

export const movingLightEffectResources = [
  { name: movingLightEffectResourceNames.star, path: 'animations/moving_light_effect/star.png' },
  {
    name: movingLightEffectResourceNames.lightEffectSpine,
    path: 'animations/moving_light_effect/moving_light_effect.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/moving_light_effect/moving_light_effect.atlas',
      },
    },
  },
];

export const bonusSharedResources = [
  { name: preBonusRssNames.preBonusFreeSpinContent, path: 'assets/free_spins_back.png' },
  { name: preBonusRssNames.preBonusMultiplierContent, path: 'assets/multiplier_back.png' },
  { name: preBonusRssNames.preBonusCrystalsContent, path: 'assets/wins_back.png' },
  { name: preBonusRssNames.bonusRectangleSmall, path: 'assets/bonus_rectangle_small.png' },
  { name: preBonusRssNames.preBonusCrystalYellow, path: 'assets/diamond_yellow.png' },
  { name: preBonusRssNames.preBonusCrystalGreen, path: 'assets/diamond_green.png' },
  { name: preBonusRssNames.preBonusCrystalBlue, path: 'assets/diamond_blue.png' },
  { name: preBonusRssNames.preBonusCrystalMagenta, path: 'assets/diamond_magenta.png' },
  ...movingLightEffectResources,
  ...crystalsResources,
];


export const bonusPreBonusSharedRssNames = {
  freeSpinContent: 'bonusPreBonusSharedRssNames_freeSpinContent',
  multiplierContent: 'bonusPreBonusSharedRssNames_multiplierContent',
  crystalsContentX2: 'bonusPreBonusSharedRssNames_crystalsContentX2',
  crystalsContentX3: 'bonusPreBonusSharedRssNames_crystalsContentX3',
  crystalsContentX3_Big: 'bonusPreBonusSharedRssNames_crystalsContentX3_Big',
  text_container: 'bonusPreBonusSharedRssNames_text_container.png',
  button_container: 'bonusPreBonusSharedRssNames_button_container.png',
  crystalsContentX4: 'bonusPreBonusSharedRssNames_crystalsContentX4',
  crystalYellow: diamondNames.diamond_yellow,
  crystalGreen: diamondNames.diamond_green,
  crystalBlue: diamondNames.diamond_blue,
  crystalMagenta: diamondNames.diamond_magenta,
  preBonus_light_effect: 'pre_bonus_light_effect',
  pre_bonus_free_spin_light_effect: 'pre_bonus_free_spin_light_effect',
  pre_bonus_crystal_light_effect: 'pre_bonus_crystal_light_effect',
};

export const bonusPreBonusSharedResources = [
  { name: bonusPreBonusSharedRssNames.freeSpinContent, path: 'assets/free_spins_back.png' },
  { name: bonusPreBonusSharedRssNames.multiplierContent, path: 'assets/multiplier_back.png' },
  { name: bonusPreBonusSharedRssNames.crystalsContentX4, path: 'assets/wins_back.png' },
  { name: bonusPreBonusSharedRssNames.crystalsContentX3, path: 'assets/gems_back_x3.png' },
  { name: bonusPreBonusSharedRssNames.crystalsContentX3_Big, path: 'assets/gems_back_x3_Big.png' },
  { name: bonusPreBonusSharedRssNames.text_container, path: 'assets/text_container.png' },
  { name: bonusPreBonusSharedRssNames.button_container, path: 'assets/button_container.png' },
  { name: bonusPreBonusSharedRssNames.crystalsContentX2, path: 'assets/bonus_rectangle_small.png' },
  {
    name: bonusPreBonusSharedRssNames.preBonus_light_effect,
    path: 'animations/pre_bonus_light_effect/light_effect.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/pre_bonus_light_effect/light_effect.atlas',
      },
    },
  },
  {
    name: bonusPreBonusSharedRssNames.pre_bonus_free_spin_light_effect,
    path: 'animations/pre_bonus_free_spin_light_effect/light_effect_free_spin.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/pre_bonus_free_spin_light_effect/light_effect_free_spin.atlas',
      },
    },
  },
  {
    name: bonusPreBonusSharedRssNames.pre_bonus_crystal_light_effect,
    path: 'animations/pre_bonus_crystal_light_effect/light_effect_yellow.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/pre_bonus_crystal_light_effect/light_effect_yellow.atlas',
      },
    },
  },
  ...diamondResources,
];

export const preBonusStoneNames = {
  opacity: 'preBonusStoneNames_opacity',
  green_crystal: diamondNames.diamond_green,
  blue_crystal: diamondNames.diamond_blue,
  magenta_crystal: diamondNames.diamond_magenta,
  yellow_crystal: diamondNames.diamond_yellow,
};

/**
 * enum
 * @type {{}}
 */
export const PreBonusTypes = {
  greenCrystal: 'green_crystal',
  blueCrystal: 'blue_crystal',
  magentaCrystal: 'magenta_crystal',
  yellowCrystal: 'yellow_crystal',
  multiplier: 'multiplier',
  freeSpin: 'freeSpin',
};

export const crystalToDiamond = {
  [crystalTypes.crystal_blue]: PreBonusTypes.blueCrystal,
  [crystalTypes.crystal_green]: PreBonusTypes.greenCrystal,
  [crystalTypes.crystal_magenta]: PreBonusTypes.magentaCrystal,
  [crystalTypes.crystal_yellow]: PreBonusTypes.yellowCrystal,
};

export const preBonusTextures = [
  PreBonusTypes.greenCrystal,
  PreBonusTypes.magentaCrystal,
  PreBonusTypes.yellowCrystal,
  PreBonusTypes.multiplier,
  PreBonusTypes.freeSpin,
];

export const preBonusStoneResources = [
  { name: preBonusStoneNames.opacity, path: 'assets/preBonusStones/opacity.svg' },
  ...diamondResources,
];

export const bigWinRssNames = {
  bigWinMobileCoins: 'big_win_mobile_coins',
  bigWinMobileWord: 'big_win_mobile_word',
  bigWinDesktopCoins: 'big_win_mobile_coins_desktop',
  bigWinDesktopWord: 'big_win_mobile_word_desktop',
  epicWin: 'epic_win',
  maxWin: 'max_win',
  megaWin: 'mega_win',
  superWin: 'super_win',
  mobileEpicWin: 'mobile_epic_win',
  mobileMaxWin: 'mobile_max_win',
  mobileMegaWin: 'mobile_mega_win',
  mobileSuperWin: 'mobile_super_win',
  coins: 'bigWinRssNames_coins',
  coins2: 'bigWinRssNames_coins2',
  mobileCoins: 'bigWinRssNames_mobile_coins',
  mobileCoins2: 'bigWinRssNames_mobile_coins2',
};

export const bigWinMobileResources = [
  new SpineFile({
    name: bigWinRssNames.bigWinMobileCoins,
    path: 'animations/big_win',
    fileName: 'mobile_big_win_mobile_coins',
  }),
  new SpineFile({
    name: bigWinRssNames.bigWinMobileWord,
    path: 'animations/big_win',
    fileName: 'mobile_big_win_word',
  }),
  new SpineFile({
    name: bigWinRssNames.mobileEpicWin,
    path: 'animations/big_win/mobile_epic_win',
    fileName: 'epic_win',
  }),
  new SpineFile({
    name: bigWinRssNames.mobileMaxWin,
    path: 'animations/big_win/mobile_max_win',
    fileName: 'max_win',
  }),
  new SpineFile({
    name: bigWinRssNames.mobileMegaWin,
    path: 'animations/big_win/mobile_mega_win',
    fileName: 'mega_win',
  }),
  new SpineFile({
    name: bigWinRssNames.mobileSuperWin,
    path: 'animations/big_win/mobile_super_win',
    fileName: 'super_win',
  }),
  { name: bigWinRssNames.mobileCoins, path: 'assets/big_win_coins/1mob.png' },
  { name: bigWinRssNames.mobileCoins2, path: 'assets/big_win_coins/2mob.png' },
];

export const bigWinDesktopResources = [
  new SpineFile({
    name: bigWinRssNames.bigWinDesktopCoins,
    path: 'animations/big_win',
    fileName: 'big_win',
  }),
  new SpineFile({
    name: bigWinRssNames.bigWinDesktopWord,
    path: 'animations/big_win',
    fileName: 'big_win_word',
  }),
  new SpineFile({
    name: bigWinRssNames.epicWin,
    path: 'animations/big_win/epic_win',
    fileName: 'epic_win',
  }),
  new SpineFile({
    name: bigWinRssNames.maxWin,
    path: 'animations/big_win/max_win',
    fileName: 'max_win',
  }),
  new SpineFile({
    name: bigWinRssNames.megaWin,
    path: 'animations/big_win/mega_win',
    fileName: 'mega_win',
  }),
  new SpineFile({
    name: bigWinRssNames.superWin,
    path: 'animations/big_win/super_win',
    fileName: 'super_win',
  }),
  { name: bigWinRssNames.coins, path: 'assets/big_win_coins/1.png' },
  { name: bigWinRssNames.coins2, path: 'assets/big_win_coins/2.png' },
];

export const bigWinWebResources = [];
